import { useWorkflowLiteContext } from '@/components/lite/document-viewer/idle-components/WorkflowLiteProvider'
import { useSelectedWorkflowContext } from '@/components/workflows/SelectedWorkflowProvider'
import { Document } from '@/types/documents'
import { useCallback } from 'react'

export default function useGetRelevantWorkflowState() {
  const { selectedWorkflow } = useSelectedWorkflowContext()
  const { workflow } = useWorkflowLiteContext()

  const workflowToUse = workflow || selectedWorkflow
  return useCallback(
    (document?: Document) => {
      if (!document) return
      return workflowToUse?.workflow_states?.find(
        (state) =>
          document.workflow_states_ids?.includes(state.id) ||
          document.document_workflow_states?.some(
            (dws) => dws.workflow_state_id === state.id,
          ),
      )
    },
    [workflowToUse?.workflow_states],
  )
}
